// var blockBtn = document.getElementById("block-desc-btn");
// blockBtn.setAttribute("aria-expanded", "false");
// var blockDescElement = document.getElementById("block-desc");
// if (blockDescElement) {
//   blockDescElement.removeAttribute("open");
//   blockDescElement.style.overflow = "hidden";
// }

// addItem to cart - function
async function addItem(variantId, quantity) {
  const result = await fetch("/cart/add.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
    }),
  });
}

$(function () {
  function updateMargin() {
    var windowWidth = $(window).width();
    var isSmallScreen = windowWidth < 1000;

    if (isSmallScreen) {
      var productStickyFormHeight = $(".product-sticky-form").outerHeight();
      $("#footer-ed-footer.ed-footer.footer").css({
        "margin-bottom": productStickyFormHeight + "px",
        cssText: "margin-bottom: " + productStickyFormHeight + "px !important",
      });
    } else {
      $("#footer-ed-footer.ed-footer.footer").css({
        "margin-bottom": "0px",
        cssText: "margin-bottom: 0px !important",
      });
    }
  }
  updateMargin();
  $(window).resize(function () {
    updateMargin();
  });
});

$(".collection-spotlight_btn").click(async function (e) {
  e.preventDefault();
  const ep = document.querySelectorAll(".collection-spotlight_product_title");
  let formData = {
    items: [],
  };
  ep.forEach(async function (el) {
    let item = {
      id: el.getAttribute("data-vid"),
      quantity: 1,
    };
    formData.items.push(item);
  });

  const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
        async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent,
              },
            })
          );

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: true,
              },
            })
          );
        }
      );
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});
